import styled from 'styled-components';
import * as LighthouseService from 'common/services/lighthouse.service';
import { getColor } from 'common/constants/_colors';
import { FILTER_TYPES } from 'common/constants/filters';
import { Link } from '@material-ui/core';
import { ARTICLE_IDS } from 'common/constants/constants';

const StyledMissingFiltersScopes = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;

  & > header {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  & > main {
    color: ${getColor('shuttleGray')};
  }
`;

const mapFilterTypeToConfig = {
  [FILTER_TYPES.ORGANIZATION_TEAMS]: {
    entityName: 'team',
    articleId: ARTICLE_IDS.SET_JIRA_BOARD_PER_TEAM,
    articleText: 'Learn how to define a team scope'
  }
};

const MissingFiltersScopes = ({ filterType }) => {
  const {
    entityName = 'entity',
    articleId,
    articleText
  } = mapFilterTypeToConfig[filterType] || {};

  return (
    <StyledMissingFiltersScopes>
      <header>Missing Scope</header>
      <main>
        This {entityName} currently has no defined scope, <br />
        so the view will not be filtered. <br />
        <Link onClick={() => LighthouseService.navigateArticle(articleId)}>
          {articleText}
        </Link>
      </main>
    </StyledMissingFiltersScopes>
  );
};

export default MissingFiltersScopes;
